import { memo } from "react";

// Builders
import { serviceTypeCardBuilder } from "../../../builders/serviceTypeCard.builder";

// Styles
import { ServiceTypeFormCardStyles } from "./serviceTypeFormCard.styles";

const ServiceTypeFormCard = ({
  serviceType,
  handleCapactyChange,
  value,
  onToggle
}) => {
  const isActive = !!value?.mobility;
  const { Icon, name } = serviceTypeCardBuilder(serviceType.typeKey);

  return (
    <ServiceTypeFormCardStyles $isActive={isActive}>
      <div className="cardHeader">
        <div className="iconWrapper">{Icon}</div>
        <div
          className="toggle"
          role="switch"
          aria-checked={isActive}
          tabIndex={0}
          onClick={() => onToggle(serviceType)}
          onKeyDown={e => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              onToggle(serviceType);
            }
          }}
        />
      </div>
      <div className="cardBody">
        <p className="serviceTypeName">{name}</p>
      </div>
      <div className="capacitySection">
        <label className="capacityLabel">Capacity</label>
        <input
          type="text"
          pattern="[0-9]+"
          className="capacityInput"
          placeholder="0"
          value={value ? value.capacity : ""}
          onChange={e => handleCapactyChange(e, serviceType.id)}
        />
      </div>
    </ServiceTypeFormCardStyles>
  );
};

export default memo(ServiceTypeFormCard);
